/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
/** @jsxImportSource @emotion/react */
import TextContent from '@cloudscape-design/components/text-content';
import { css } from '@emotion/react';
import { FC, ReactNode } from 'react';
import { TemplateThreatStatement } from '../../../customTypes';
import CopyToClipbord from '../../generic/CopyToClipboard';

export interface FinalStatementProps {
  statement: TemplateThreatStatement;
  displayStatement?: ReactNode[];
}

const FinalStatement: FC<FinalStatementProps> = ({ statement, displayStatement }) => {
  return (
    <TextContent>
      <p css={css`
        font-size: 20px !important;
        line-height: 1.5 !important;
      `}
      >
        {(statement.statement || (displayStatement && displayStatement.length > 0)) && <CopyToClipbord content={statement.statement}>
          {displayStatement ? displayStatement : statement.statement}
        </CopyToClipbord>}
      </p>
    </TextContent>
  );
};

export default FinalStatement;
